var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTabBarFolderDefault = function SvgTabBarFolderDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#303742",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M2 8.348v7.977a4.324 4.324 0 0 0 4.324 4.324h11.352A4.324 4.324 0 0 0 22 16.325v-6.151a4.324 4.324 0 0 0-4.324-4.325H12M2 8.348V6.59a3.243 3.243 0 0 1 3.243-3.243h3.135a2.7 2.7 0 0 1 1.912.791L12 5.85l-1.706 1.706a2.7 2.7 0 0 1-1.911.792z"
  })));
};
export default SvgTabBarFolderDefault;